import Routes from '$provider/constants/Route';
import { redirect, type LoadEvent } from '@sveltejs/kit';

export const ssr = false;

// When running inside an iframe during the embed init flow, replace pushState with replaceState
// so the iframe never accumulates history entries. Checked at module eval time (before any load
// function) so it covers the initial navigation. ssr=false on this layout means this only runs
// in the browser, but the optional chaining on location and history guards against any edge cases.
if (
  globalThis.parent !== globalThis &&
  new URLSearchParams(globalThis.location?.search ?? '').has('target')
) {
  globalThis.history?.pushState &&
    (globalThis.history.pushState = globalThis.history.replaceState.bind(globalThis.history));
}

/** @type {import('./$types').LayoutLoad} */
export function load({ url }: LoadEvent): void {
  if (url.pathname === '/') {
    throw redirect(302, Routes.Login);
  }
  return;
}
